/**
 * WAI-ARIA Authoring Practices GuideのTab patternに沿ったroving tabindexの
 * キー操作を計算する。ArrowRight/ArrowLeftで隣接タブへ(端はループ)、
 * Home/Endで先頭/末尾のタブへ移動する。対象外のキーはnullを返す。
 * @see https://www.w3.org/WAI/ARIA/apg/patterns/tabs/
 * @param currentIndex - 現在選択中のタブのindex
 * @param key - KeyboardEvent.key
 * @param tabCount - タブの総数
 * @returns 次に選択・フォーカスすべきタブのindex、対象外のキーの場合はnull
 */
export function getNextTabIndex(
  currentIndex: number,
  key: string,
  tabCount: number,
): number | null {
  if (tabCount <= 0) return null;
  switch (key) {
    case "ArrowRight":
      return (currentIndex + 1 + tabCount) % tabCount;
    case "ArrowLeft":
      return (currentIndex - 1 + tabCount) % tabCount;
    case "Home":
      return 0;
    case "End":
      return tabCount - 1;
    default:
      return null;
  }
}
